import { createElement, HTMLAttributes } from 'react';

import * as Icons from './icons';
import { StyledIcon } from './styled';

type IconName = keyof typeof Icons;

interface IconProps extends HTMLAttributes<HTMLSpanElement> {
  icon: IconName;
  className?: string;
  withParentColor?: boolean;
  size?: number | string;
  // This allows passing props directly to the icon component
  [key: string]: any;
}
export const Icon = ({ icon, className, withParentColor = true, size = 20, ...props }: IconProps) => {
  const IconComponent = Icons[icon];
  if (!IconComponent) {
    console.warn(`Icon "${icon}" does not exist in the Icons module.`);
    return null;
  }

  const component = createElement(IconComponent, props);

  return (
    <StyledIcon className={`icon ${className}`} $size={size} $withParentColor={withParentColor}>
      {component}
    </StyledIcon>
  );
};
